<template>
  <div id="app">
    <el-container style="height: 100vh;">
      <el-aside width="200px" style="background-color: #304156; color: #fff;overflow: hidden;">
        <Sidebar />
      </el-aside>
      <el-container>
        <el-header style="background-color: #fff; border-bottom: 1px solid #e6e6e6;">
          <div class="header-content">
            <div class="logo">优特科保管理后台</div>
            <div class="user-info">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <!-- <el-avatar icon="el-icon-user" class="avatar" /> -->
                  <span style="margin-left: 8px;cursor: pointer;">{{ username }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>个人中心</el-dropdown-item>
                  <el-dropdown-item @click.native="logout">
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'

export default {
  name: 'App',
  components: {
    Sidebar
  },
  data() {
    return {
      username: JSON.parse(localStorage.getItem('user')).sysAccount.username
    }
  },
  created() {
    // console.log("999---", this.username)
  },
   methods: {
    logout() {
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      localStorage.removeItem("cachedMenu")
      localStorage.removeItem("cachedMenuToken")
      this.$router.push('/login')
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0;
  .amap-sug-result {
    z-index: 3999 !important;

  }
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  font-size: 18px;
  font-weight: bold;
  color: #1890ff;
}

.user-info {
  display: flex;
  align-items: center;
}

.avatar {
  width: 36px;
  height: 36px;
}
</style>
